import { useCallback } from 'react';

import { graphql, useMutation } from 'react-relay';

import type {
	useSetNavCustomizationDataMutation as CustomisationMutationType,
	useSetNavCustomizationDataMutation$variables,
} from './__generated__/useSetNavCustomizationDataMutation.graphql';

/**
 * useSetNavCustomizationData - returns a setter function to update the user customization data.
 * This can be used by the CustomizationModal to update the sidebar customization data.
 * The CustomizationModal will *read* the data from
 *
 * @experimental
 * Still under development. Use with caution.
 */
export function useSetNavCustomizationData() {
	const [mutation] = useMutation<CustomisationMutationType>(graphql`
		mutation useSetNavCustomizationDataMutation(
			$entityAri: ID!
			$ownerAri: ID!
			$sidebar: [SettingsMenuItemInput]
		) {
			settings_updateNavigationCustomisation(
				input: { entityAri: $entityAri, ownerAri: $ownerAri, sidebar: $sidebar }
			) {
				sidebar {
					nodes {
						menuId
						visible
					}
				}
			}
		}
	`);

	const setCustomizationData = useCallback(
		async (variables: useSetNavCustomizationDataMutation$variables) => {
			try {
				return mutation({
					variables,
					onCompleted: () => {
						// TODO: fire analytic event for success after NAVX-490 is merged
					},
					onError: (error) => {
						// TODO: fire analytic event for success after NAVX-490 is merged
					},
				});
			} catch (error) {
				// Re-throw go to error boundary
			}
		},
		[mutation],
	);

	return setCustomizationData;
}
